// Accessible Play/Pause for Cover Block Videos (Font Awesome version)
document.addEventListener("DOMContentLoaded", function () {
	document
		.querySelectorAll(".wp-block-cover video")
		.forEach(function (video) {
			const cover = video.closest(".wp-block-cover");
			if (cover && !cover.querySelector(".cover-video-toggle")) {
				const btn = document.createElement("button");
				btn.className = "cover-video-toggle is-playing";
				btn.setAttribute("type", "button");
				btn.setAttribute("aria-label", "Pause background video");
				btn.setAttribute("aria-pressed", "false");
				btn.innerHTML =
					'<span class="visually-hidden">Pause background video</span>';

				cover.appendChild(btn);

				btn.addEventListener("click", function () {
					if (video.paused) {
						video.play();
						btn.classList.remove("is-paused");
						btn.classList.add("is-playing");
						btn.setAttribute(
							"aria-label",
							"Pause background video",
						);
						btn.setAttribute("aria-pressed", "false");
						btn.innerHTML =
							'<span class="visually-hidden">Pause background video</span>';
					} else {
						video.pause();
						btn.classList.remove("is-playing");
						btn.classList.add("is-paused");
						btn.setAttribute("aria-label", "Play background video");
						btn.setAttribute("aria-pressed", "true");
						btn.innerHTML =
							'<span class="visually-hidden">Play background video</span>';
					}
				});
			}
		});
});
